import React, { memo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { AiChatTestIds } from '../../AiChat.testIds';
import AiChatActivityBar from '../AiChatActivityBar';
import AiChatInput from '../AiChatInput';

import { getFooterDividerStyles } from './AiChatFooter.styles';

const AiChatFooter = ({ disabled, onSend, onStop, isInFlight = false, isScrolled = false }) => {
  return (
    <Box data-testid={AiChatTestIds.AI_CHAT_FOOTER} sx={getFooterDividerStyles(isScrolled)}>
      <AiChatActivityBar />
      <AiChatInput disabled={disabled} isInFlight={isInFlight} onSend={onSend} onStop={onStop} />
    </Box>
  );
};

AiChatFooter.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onSend: PropTypes.func.isRequired,
  isInFlight: PropTypes.bool,
  isScrolled: PropTypes.bool,
  onStop: PropTypes.func,
};

export default memo(AiChatFooter);
